import { useState } from "react";

export function Newsletter() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitted(true);
  }

  return (
    <section className="w-full bg-white py-12 px-4">
      <div className="max-w-site mx-auto">
        <form onSubmit={handleSubmit} className="max-w-xl mx-auto">
          <h5 className="font-heading text-2xl text-[#1e2025] mb-6">
            Be the first to know!
          </h5>

          {submitted ? (
            <p className="text-[#1e2025] font-body">Thanks for subscribing!</p>
          ) : (
            <>
              <div className="flex flex-col sm:flex-row gap-4 mb-4">
                <div className="flex-1">
                  <label
                    htmlFor="first-name"
                    className="block text-sm font-body text-[#50556a] mb-1"
                  >
                    First Name
                  </label>
                  <input
                    id="first-name"
                    name="first-name"
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="w-full border border-[#c2c5cd] px-3 py-2 text-sm text-[#1e2025] focus:outline-none focus:border-[#1b1a21]"
                  />
                </div>

                <div className="flex-1">
                  <label
                    htmlFor="last-name"
                    className="block text-sm font-body text-[#50556a] mb-1"
                  >
                    Last Name
                  </label>
                  <input
                    id="last-name"
                    name="last-name"
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="w-full border border-[#c2c5cd] px-3 py-2 text-sm text-[#1e2025] focus:outline-none focus:border-[#1b1a21]"
                  />
                </div>

                <div className="flex-1">
                  <label
                    htmlFor="email"
                    className="block text-sm font-body text-[#50556a] mb-1"
                  >
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full border border-[#c2c5cd] px-3 py-2 text-sm text-[#1e2025] focus:outline-none focus:border-[#1b1a21]"
                  />
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="bg-[#1b1a21] text-white font-button text-sm px-6 py-2 hover:bg-[#0d0c11] transition-colors"
                  style={{ borderRadius: "20px" }}
                >
                  Subscribe
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </section>
  );
}
